
import FF_Module from './FF_Module'; // eslint-disable-line no-autofix/snakecasejs/snakecasejs

/**
 * Module qui modifie le HTML des CTAs (.cta) pour y ajouter les flèches à l'intérieur.
 */
export default class FF_CTA extends FF_Module {
  init() {
    this.arrow_svg = $('#global-references .arrow-line-icon').get(0).outerHTML;
    $(this.elements.container)
      .append(`<span class="${this.module_css_class}__arrows">${this.arrow_svg + this.arrow_svg}</span>`)
      .find('.arrow-line-icon')
      .removeClass('arrow-line-icon')
      .addClass(`${this.module_css_class}__arrow`);
  }

  static create(element) {
    new FF_CTA(element); // eslint-disable-line no-new
  }
}
